export default "__VITE_ASSET__jOqbsdqR__"